import type {
  BBAnnotationStyles,
  BoundingBoxCoordinate,
  Offest,
} from '../types';

export const drawOval = (input: {
  coordintate: BoundingBoxCoordinate;
  styles: BBAnnotationStyles;
  context: CanvasRenderingContext2D;
  offset?: Offest;
  scale?: number;
}) => {
  const {
    coordintate,
    styles,
    context,
    offset = { dx: 0, dy: 0 },
    scale = 1,
  } = input;
  context.beginPath();
  context.strokeStyle = styles.strokeColor;
  context.lineWidth = styles.strokeWidth;
  if (styles.strokeDashArray) {
    context.setLineDash(styles.strokeDashArray);
  }
  // For an oval, we need the center point and the radii
  const centerX = (coordintate.x + offset.dx + coordintate.width / 2) * scale;
  const centerY = (coordintate.y + offset.dy + coordintate.height / 2) * scale;
  const radiusX = (coordintate.width / 2) * scale;
  const radiusY = (coordintate.height / 2) * scale;

  context.ellipse(
    centerX,
    centerY,
    radiusX,
    radiusY,
    0, // rotation
    0, // start angle
    2 * Math.PI, // end angle (full circle)
  );
  context.stroke();
};
